import { render, staticRenderFns } from "./TwofactorLoginComponent.vue?vue&type=template&id=548ce5c5"
import script from "./TwofactorLoginComponent.vue?vue&type=script&lang=js"
export * from "./TwofactorLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./TwofactorLoginComponent.vue?vue&type=style&index=0&id=548ce5c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports